import React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import {
  SignableOrganizationPerCountry,
  taxAgencyOrgsTexts,
} from 'modules/expenses/hooks/useTaxAgencyHomologations'

import TermsModal from './TermsModal'

interface LegalComplianceTermsItemProps {
  organization: SignableOrganizationPerCountry
  enabled: boolean
}

const LegalComplianceTermsItem = ({ enabled, organization }: LegalComplianceTermsItemProps) => {
  const [showTermsModal, setShowTermsModal] = React.useState(false)

  return (
    <>
      <Box width="full" flexDirection="row" justifyContent="center" alignItems="flexStart" gap="s8">
        <Icon.Medium icon="alert-circle-line" color="grey800" />
        <Box flexGrow gap="s4">
          <Text.Normal weight="medium" size="300" color="grey1000">
            {taxAgencyOrgsTexts(organization).termsTitle}
          </Text.Normal>
          <Text.Normal weight="normal" size="200" color="grey700">
            {taxAgencyOrgsTexts(organization).termsDescription}
          </Text.Normal>
        </Box>
        <Box>
          <Button
            aria-label="accept terms"
            type="secondary"
            onClick={() => setShowTermsModal(true)}
            disabled={!enabled}
            iconName="pencil"
          />
        </Box>
      </Box>
      {showTermsModal && (
        <TermsModal
          organization={organization}
          termsLink={taxAgencyOrgsTexts(organization).termsLink}
          title={taxAgencyOrgsTexts(organization).termsModalTitle}
          description={taxAgencyOrgsTexts(organization).termsModalDescription}
          onClose={() => setShowTermsModal(false)}
        />
      )}
    </>
  )
}

export default LegalComplianceTermsItem
